import { useAuth } from '@core/context/AuthContext';
import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * PublicRoute - Prevents authenticated users from accessing public pages (like Login).
 * Redirects them to the appropriate dashboard based on their role and terminal mode.
 */
const PublicRoute = ({ children }) => {
    const { user, loading, isTerminalMode } = useAuth();

    if (loading) return null; // Wait for auth to resolve

    if (user) {
        // If already logged in, redirect to the correct place
        if (isTerminalMode) return <Navigate to="/terminal" replace />;
        return <Navigate to={user.role === 'ADMIN' ? "/catalogs" : "/terminal"} replace />;
    }

    return children;
};

export default PublicRoute;
